import { useState } from 'react';

interface IUseLostDealDialogProps {
    isOpen?: boolean;
    onOpenChange?: (open: boolean) => void;
    onClose: () => void;
}

export const useLostDealDialog = ({
    isOpen,
    onOpenChange,
    onClose,
}: IUseLostDealDialogProps) => {
    const [uncontrolledOpen, setUncontrolledOpen] = useState(false);
    const isDialogOpen = isOpen ?? uncontrolledOpen;

    const handleDialogOpenChange = (nextOpen: boolean) => {
        setUncontrolledOpen(nextOpen);
        onOpenChange?.(nextOpen);

        if (!nextOpen) {
            onClose();
        }
    };

    return {
        isDialogOpen,
        handleDialogOpenChange,
    };
};
